// extracted by mini-css-extract-plugin
export var bodySections = "_4f-8";
export var gray = "_4f-7";
export var green = "_4f-4";
export var iconContainer = "_4f-9";
export var iconWidgetContainer = "_4f-1";
export var phoneIcon = "_4f-2";
export var red = "_4f-5";
export var statusDot = "_4f-3";
export var widgetContainer = "_4f-0";
export var yellow = "_4f-6";